<template>
  <div class="home_container">
    <HomeHeader :collegeDetail="collegeDetail" :collegeList="collegeList" @setIdHandle="setCollegeIdCache" />
    <PullToRefresh v-model="refreshing" @refresh="onRefresh('0')">
      <List v-model:loading="loading" :finished="finished" @load="onLoad">
        <template v-for="(item, index) in modules" :key="index">
          <Banner v-if="item.code === 'app-banner'" :data="item" />
          <Menu v-if="item.code === 'app-nav'" :data="item" :badgeNum="badgeNum" />
          <Announcement v-if="item.code === 'app-notice'" :data="item" />
          <TodoList v-if="item.code === 'app-learn-task'" :data="item" :badgeNum="badgeNum" />
          <LiveStream v-if="item.code === 'app-live-stream'" :data="item" />
          <Course v-if="item.code === 'app-class'" :data="item" />
          <Course v-if="item.code === 'app-category-class'" :data="item" />
          <Broadcast v-if="item.code === 'app-info'" :data="item" />
          <BroadcastAndCourse v-if="item.code === 'app-info-class'" :data="item" />
          <Popularize v-if="item.code === 'app-multi-image'" :data="item" />
          <div v-if="item.code === 'app-community'" class="community_wrapper">
            <CardTitle :title="item.title" class="community_title" skipPage="/community" />
            <ArticleCard :articleData="comunnityData" :active="0" @showPreview="showPreview" />
          </div>
          <Instructor v-if="item.code === 'app-lecturer'" :data="item" />
        </template>
        <template #loading>
          <Loading size="20" />
        </template>
      </List>
    </PullToRefresh>
    <Advertise v-model="advertiseShow" :data="advertiseList" />
    <BackTop bottom="100px" />
    <ImgPreview
      :imageList="imageList"
      :previewIndex="previewIndex"
      :previewShow="previewShow"
      @closePreview="handleClose"
    ></ImgPreview>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, onActivated, onMounted, getCurrentInstance, ComponentInternalInstance } from 'vue'
import { List, Loading } from 'vant'
import { storeToRefs } from 'pinia'
import 'swiper/css'
import 'swiper/css/autoplay'
import HomeHeader from './HomeHeader.vue'
import Banner from './Banner.vue'
import Menu from './Menu.vue'
import Course from './Course.vue'
import Announcement from './Announcement.vue'
import TodoList from './TodoList.vue'
import LiveStream from './LiveStream.vue'
import Broadcast from './Broadcast.vue'
import BroadcastAndCourse from './BroadcastAndCourse.vue'
import Popularize from './Popularize.vue'
import Instructor from './Instructor.vue'
import { useThemeColorWithAlpha } from '@/utils/theme'
import { postCollegeList, postHomeConfig } from '@/api/requests/HomeRequests'
import { CollegeDetail, LmsDecorateModule } from '@/api/Models/HomeConfig'
import CardTitle from './CardTitle.vue'
import { Record } from '@/api/Models/CommunityBoardContentList'
import ArticleCard from '@/views/community/components/ArticleCard.vue'
import APIRequest from '@/api'
import { useUsersStore } from '@/stores/users'
import { useAuthStore } from '@/stores/login'
import { useSystemStore } from '@/stores/system'
import { College } from '@/api/Models/CollegeList'
import Advertise from '@/views/home/Advertise.vue'
import { Record as AdvertiseRecord } from '@/api/Models/HomeAdvertiseList'
import BackTop from '@/components/BackTop.vue'
import { Attachment } from '@/api/Models/Attachment'
import ImgPreview from '@/components/ImgPreview.vue'
import PullToRefresh from '@/components/PullToRefresh.vue'

const badgeNum = ref(0)
const getNum = async () => {
  const { data, code } = await APIRequest.MyLearning.getMyLearningTask({
    taskStatus: 100,
    size: 5,
    current: 1
  })
  if (code === 1) {
    badgeNum.value = data.total
  }
}
onActivated(() => {
  getNum()
})
onMounted(() => {
  getNum()
})

const imageList = ref<string[]>([] as string[])
const previewShow = ref(false)
const previewIndex = ref(0)
const showPreview = (data: { attachments: Attachment[]; index: number }) => {
  imageList.value = data?.attachments.map((item) => item.previewUrl || '')
  previewShow.value = true
  previewIndex.value = data.index
}
const handleClose = () => {
  previewShow.value = false
}

const advertiseList = ref<AdvertiseRecord[]>([])
const advertiseShow = ref(false)

const getAdvertise = async () => {
  console.log('开始调用广告接口')
  const { code, data } = await APIRequest.Home.getHomeAdvertiseList({
    location: '0',
    current: 1,
    size: 4
  })

  console.log('广告接口返回:', { code, data })

  if (code === 1) {
    // 修改过滤逻辑，去除空格并检查URL有效性
    const records = (data.records || []).filter((e) => {
      const trimmedUrl = e.appImgUrl?.trim()
      return trimmedUrl && trimmedUrl.length > 0
    })

    console.log('过滤后的records:', records, 'length:', records.length)
    console.log('第一条数据的appImgUrl:', records[0]?.appImgUrl)

    if (records.length > 0) {
      // 清理URL中的空格
      const cleanedRecords = records.map((record) => ({
        ...record,
        appImgUrl: record.appImgUrl?.trim()
      }))

      // 先设置数据
      advertiseList.value = cleanedRecords
      console.log('广告数据已设置:', advertiseList.value)

      // 使用延迟确保页面完全加载后再显示弹窗
      advertiseShow.value = true
    }
    localStorage.removeItem('fromLogin')
  } else {
    console.log('接口调用失败，code:', code)
    // 接口失败时也重置状态
    advertiseList.value = []
    advertiseShow.value = false
  }
}

const loading = ref(false)
const finished = ref(true)
const refreshing = ref(false)
let current = 2
let comunnitySort = 0
let comunnityBoardIds = ''
const onLoad = async () => {
  if (refreshing.value) {
    comunnityData.value = []
    refreshing.value = false
  }
  const { code, data } = await APIRequest.Community.getCommunityBoardContentList({
    current,
    size: 12,
    sortType: (comunnitySort + 1).toString(),
    boardIds: comunnityBoardIds ? comunnityBoardIds.split(',').map((id) => parseInt(id.trim())) : []
  })
  loading.value = false
  if (code === 1) {
    console.log(data)
    if (!data.records || data.records.length === 0) {
      finished.value = true
    }
    current++
    comunnityData.value.push(...data.records)
  } else {
    finished.value = true
  }
}

const { proxy } = getCurrentInstance() as ComponentInternalInstance
proxy?.$bus.on('thumbup', ({ id, likeCount, isLike }: { id: string; likeCount: number; isLike: boolean }) => {
  console.log(comunnityData.value)
  const cur = comunnityData.value.find((item) => {
    return item.id === id
  })
  if (cur) {
    cur.isLike = isLike
    cur.likeCount = Number(likeCount)
  }
})

const usersStore = useUsersStore()
const { collegeId } = storeToRefs(usersStore)
const collegeIdCache = ref(collegeId.value)
const setCollegeIdCache = (id: string) => {
  collegeIdCache.value = id
}
const { setCollegeId } = usersStore
const onRefresh = (loadingType?: '0' | '1') => {
  current = 2
  init(loadingType)
}

const collegeDetail = ref({} as CollegeDetail)
const modules = ref([] as LmsDecorateModule[])
const comunnityData = ref<Record[]>([])

const init = async (type?: '0' | '1') => {
  finished.value = true
  const res = await postHomeConfig(
    {
      clientType: 3,
      collegeId: collegeIdCache.value,
      readCache: 0,
      switchCollege: 1,
      templateId: ''
    },
    type
  )
  // console.log(res)
  const { code, data } = res
  refreshing.value = false
  if (code === 1) {
    setCollegeId(collegeIdCache.value)
    collegeDetail.value = data.collegeDetail
    modules.value = data.lmsDecorateModules
    for (let i = 0; i < data.lmsDecorateModules.length; i++) {
      const item = data.lmsDecorateModules[i]
      if (item.code === 'app-community') {
        const lmsDecorateModuleCategories = item.lmsDecorateModuleCategories[0]
        const json = lmsDecorateModuleCategories.datas[0].json
        try {
          comunnityData.value = JSON.parse(json)
          comunnitySort = lmsDecorateModuleCategories.dataShowRule || 0
          comunnityBoardIds = (lmsDecorateModuleCategories.dataJumpIds || []).join(',')
        } catch (error) {
          console.log(error)
        }
        if (item.isFeedStream === 1) {
          finished.value = false
        }
      }
    }
  }
}

const collegeList = ref<College[]>([])
const authStore = useAuthStore()
const { userId } = storeToRefs(authStore)

watch(
  userId,
  async (newUserId, oldUserId) => {
    console.log(newUserId, oldUserId, userId, '============')

    collegeIdCache.value = collegeId.value

    const shouldCallAdvertise = localStorage.getItem('fromLogin')

    console.log(shouldCallAdvertise, 'shouldCallAdvertise=========', shouldCallAdvertise === 'true')

    if (shouldCallAdvertise && shouldCallAdvertise === 'true') {
      getAdvertise()
    }

    const { code, data } = await postCollegeList()
    if (code === 1) {
      if (collegeId.value === '-1') {
        collegeIdCache.value = data.colleges[0]?.id
      }
      collegeList.value = data.colleges
      onRefresh()
    }
  },
  {
    immediate: true
  }
)

const systemStore = useSystemStore()
const { lang } = storeToRefs(systemStore)
watch([collegeIdCache, lang], () => {
  onRefresh()
})

const themeColorWithAlpha = useThemeColorWithAlpha(0.6)
</script>
<script lang="ts">
export default {
  name: 'tab'
}
</script>
<style lang="less" scoped>
@import url('@/styles/variables.less');

.home_container {
  padding-top: 44px;

  .text {
    color: @textPrimary;
  }

  .text2 {
    color: v-bind(themeColorWithAlpha);
  }
  .community_wrapper {
    margin: 12px 16px;
    border-radius: 8px;
    background-color: @contentBackground;
    .community_title {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
}
</style>
